import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpmachinecredential2deleteDeleteScreenTruthMachineCredentialsIdResponseSchema = jsonObject
export type tcpmachinecredential2deleteDeleteScreenTruthMachineCredentialsIdResponse = z.infer<typeof tcpmachinecredential2deleteDeleteScreenTruthMachineCredentialsIdResponseSchema>
